// extracted by mini-css-extract-plugin
export default {"screen":"screen__0c65e1ae","primary-button":"primary-button__b9494d58","button-disabled":"button-disabled__ff402a9b"};